<template>
  <!-- company-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展会管理</div>
        <p style="line-height:40px;color:#808080;font-size:12px;">展会相关的基础数据设置</p>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '2'">
        <div class="htb-item" @click="showAdd('hostSetPavilion')">
          <span>添加展馆</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '4'">
        <div class="htb-item" @click="showAdd('hostSetSupply')">
          <span class="htb-add">+</span>
          <span>添加供需类别</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '3'">
        <div class="htb-item" @click="showAdd('hostSetProCategory')">
          <span class="htb-add">+</span>
          <span>添加类别</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '5'">
        <div class="htb-item" @click="showAdd('hostSetBusinessType')">
          <span class="htb-add">+</span>
          <span>添加企业经营类型</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '6'">
        <div class="htb-item" @click="showAdd('hostSetCatalogueType')">
          <span class="htb-add">+</span>
          <span>添加会刊企业类型</span>
        </div>
      </div>
      <!-- <div class="header-tool-box" v-if="String(showTabs) === '7'">
        <div class="htb-item" @click="showAdd('hostSetIndustryType')">
          <span class="htb-add">+</span>
          <span>添加行业类别</span>
        </div>
      </div> -->
      <div class="header-tool-box" v-if="String(showTabs) === '7'">
        <div class="htb-item" @click="showAdd('hostSetLinkMan')">
          <span class="htb-add">+</span>
          <span>添加联系人类别</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '8'">
        <div class="htb-item" @click="showAdd('hostSetComNat')">
          <span class="htb-add">+</span>
          <span>添加企业性质</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '9'">
        <div class="htb-item" @click="showAdd('hostSetProType')">
          <span class="htb-add">+</span>
          <span>添加产品标签</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '10'">
        <div class="htb-item" @click="showAdd('hostSetLabel')">
          <span class="htb-add">+</span>
          <span>添加云店标签</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '11'">
        <div class="htb-item" @click="showAdd('hostSetChannel')">
          <span class="htb-add">+</span>
          <span>添加适用渠道</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '12'">
        <div class="htb-item" @click="showAdd('hostSetOffice')">
          <span class="htb-add">+</span>
          <span>添加应用科室</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '13'">
        <div class="htb-item" @click="showAdd('hostSetAuth')">
          <span class="htb-add">+</span>
          <span>添加产品认证</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '14'">
        <div class="htb-item" @click="showAdd('hostSetQualities')">
          <span class="htb-add">+</span>
          <span>添加质量体系认证</span>
        </div>
      </div>
      <div class="header-tool-box" v-if="String(showTabs) === '15'">
        <div class="htb-item" @click="showAdd('hostSetRegion')">
          <span class="htb-add">+</span>
          <span>添加招商区域</span>
        </div>
      </div>

      <div class="header-tool-box" v-if="String(showTabs) === '16'">
        <div class="htb-item" @click="showAdd('hostSetAreaMan')">
          <span class="htb-add">+</span>
          <span>添加展区</span>
        </div>
      </div>

    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="展会信息" name="1">
          <hostExInfo ref="hostExInfo" v-if="String(showTabs) === '1'" />
        </TabPane>
        <!-- <TabPane label="展馆管理" name="2">
          <hostSetPavilion ref="hostSetPavilion" v-if="String(showTabs) === '2'" />
        </TabPane> -->
        <TabPane label="展品类别设置" name="3">
          <hostSetProCategory ref="hostSetProCategory" v-if="String(showTabs) === '3'" />
        </TabPane>
        <!-- <TabPane label="供需类别" name="4">
          <hostSetSupply ref="hostSetSupply" v-if="String(showTabs) === '4'" />
        </TabPane> -->
        <TabPane label="企业经营类型" name="5">
          <hostSetBusinessType ref="hostSetBusinessType" v-if="String(showTabs) === '5'" />
        </TabPane>
        <!-- <TabPane label="会刊企业类型" name="6">
          <hostSetCatalogueType ref="hostSetCatalogueType" v-if="String(showTabs) === '6'" />
        </TabPane> -->
        <!-- <TabPane label="行业类别" name="7">
          <hostSetIndustryType ref="hostSetIndustryType" v-if="String(showTabs) === '7'" />
        </TabPane> -->
        <TabPane label="联系人类别" name="7">
          <hostSetLinkMan ref="hostSetLinkMan" v-if="String(showTabs) === '7'" />
        </TabPane>

        <TabPane label="企业性质" name="8">
          <hostSetComNat ref="hostSetComNat" v-if="String(showTabs) === '8'" />
        </TabPane>

        <TabPane label="展区管理" name="16">
          <hostSetAreaMan ref="hostSetAreaMan" v-if="String(showTabs) === '16'" />
        </TabPane>


        <!-- <TabPane label="产品标签" name="9">
          <hostSetProType ref="hostSetProType" v-if="String(showTabs) === '9'" />
        </TabPane> -->
        <!-- <TabPane label="云店标签" name="10">
          <hostSetLabel ref="hostSetLabel" v-if="String(showTabs) === '10'" />
        </TabPane> -->
        <!-- <TabPane label="产品适用渠道" name="11">
          <hostSetChannel ref="hostSetChannel" v-if="String(showTabs) === '11'" />
        </TabPane>
        <TabPane label="产品应用科室" name="12">
          <hostSetOffice ref="hostSetOffice" v-if="String(showTabs) === '12'" />
        </TabPane>
        <TabPane label="产品认证" name="13">
          <hostSetAuth ref="hostSetAuth" v-if="String(showTabs) === '13'" />
        </TabPane>
        <TabPane label="产品质量体系认证" name="14">
          <hostSetQualities ref="hostSetQualities" v-if="String(showTabs) === '14'" />
        </TabPane> -->
        <!-- <TabPane label="招商区域" name="15">
          <hostSetRegion ref="hostSetRegion" v-if="String(showTabs) === '15'" />
        </TabPane> -->
      </Tabs>
    </div>
  </div>
</template>

<script>
import hostSetSupply from "../host-set/subpages/host-set-supply.vue";
import hostExInfo from "../host-set/subpages/host-exInfo.vue";
import hostSetPavilion from "../host-set/subpages/host-set-pavilion.vue";
import hostSetProCategory from "../host-set/subpages/host-set-pro-category/host-set-pro-category";
import hostSetBusinessType from "../host-set/subpages/host-set-businessType.vue";  // 经营类别
import hostSetCatalogueType from "../host-set/subpages/host-set-CatalogueType.vue"; // 会刊
import hostSetLinkMan from "../host-set/subpages/host-set-linkMan.vue"; // 联系人
import hostSetComNat from "../host-set/subpages/host-set-comNat.vue"; // 企业性质
import hostSetAreaMan from "../host-set/subpages/host-set-areaMan.vue"; // 展区管理
import hostSetIndustryType from "../host-set/subpages/host-set-industryType.vue"; // 行业类别
import hostSetProType from "../host-set/subpages/host-set-proType.vue"; // 产品标签
import hostSetLabel from "../host-set/subpages/host-set-label.vue"; // 云店标签
import hostSetChannel from "../host-set/subpages/host-set-channel.vue"; // 产品试用渠道
import hostSetOffice from "../host-set/subpages/host-set-office.vue"; // 产品应用科室
import hostSetAuth from "../host-set/subpages/host-set-auth.vue"; // 产品认证
import hostSetQualities from "../host-set/subpages/host-set-qualities.vue"; // 产品质量体系认证
import hostSetRegion from "../host-set/subpages/host-set-region.vue"; // 招商区域

export default {
  name: "host-set",
  data () {
    return {
      showTabs: "1",
      show: false,
    };
  },
  components: {
    hostSetSupply,
    hostExInfo,
    hostSetPavilion,
    hostSetProCategory,
    hostSetBusinessType,
    hostSetCatalogueType,
    hostSetLinkMan,
    hostSetComNat,
    hostSetAreaMan,
    hostSetIndustryType,
    hostSetProType,
    hostSetLabel,
    hostSetChannel,
    hostSetOffice,
    hostSetAuth,
    hostSetQualities,
    hostSetRegion,
  },
  created () {
    this.changeTab();
  },
  methods: {
    changeTab () {
      let query = this.$route.query;
      if (query && query.type && query.type === "supply") {
        this.showTabs = "1";
      }
    },
    switchBrand (name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=supply`);
      }
    },
    showAdd (name) {
      this.$refs[name].showAdd();
    }
  }
};
</script>

<style scoped lang="scss">
.civ {
  .header-tool {
    padding: 18px 25px 0 35px;
  }
}
</style>
